// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4045":"200d46dc","6856":"8716c76a","7741":"3b87ce18"}[chunkId] + ".chunk.css";
};